import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../../components/Hero/Hero';
import AboutUs from '../../components/AboutUs/AboutUs';
import OurWork from '../../components/OurWork/OurWork';
import OurProcess from '../../components/OurProcess/OurProcess';
import OurServices from '../../components/OurServices/OurServices';
import Recognitions from '../../components/Recognitions/Recognitions';
import NewIdeas from '../../components/NewIdeas/NewIdeas';

const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollTo = (location.state as { scrollTo?: string } | null)?.scrollTo;
    if (scrollTo) {
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location.state]);

  return (
    <>
      <Hero />
      <AboutUs />
      <OurWork />
      <OurServices />
      <OurProcess />
      <Recognitions />
      <NewIdeas />
    </>
  );
};

export default Home;
